var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLab3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0573 43.3854L35.4167 37.099L45.776 43.3854L43.0312 31.6094L52.2396 23.6406L40.1094 22.6667L35.4167 11.5104L30.724 22.6667L18.5938 23.6406L27.8021 31.6094L25.0573 43.3854ZM0 70.8333V7.08333C0 5.13542 0.694167 3.46847 2.0825 2.0825C3.47083 0.696528 5.13778 0.00236111 7.08333 0H63.75C65.6979 0 67.366 0.694167 68.7544 2.0825C70.1427 3.47083 70.8357 5.13778 70.8333 7.08333V49.5833C70.8333 51.5312 70.1403 53.1994 68.7544 54.5877C67.3684 55.976 65.7003 56.669 63.75 56.6667H14.1667L0 70.8333ZM11.1562 49.5833H63.75V7.08333H7.08333V53.5677L11.1562 49.5833Z",
    fill: "#00665A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLab3);
export default __webpack_public_path__ + "static/media/lab3.8ec3ec70f49916c465c9acbd75dd3ee4.svg";
export { ForwardRef as ReactComponent };